import { FC } from "react";
import { useParams } from "react-router-dom";

import { RideEditFormDrawer } from "@ryde/layout";
import { useRidesNavigation } from "@ryde/redux";
import { DrawerType, EditFormMode } from "@ryde/shared";

interface IRideEdit {
  isAddRoute?: boolean;
}

export const RideEdit: FC<IRideEdit> = ({ isAddRoute }) => {
  const { id } = useParams<{ id: string }>();
  const { navigateRidesGridOrKanbanOrMap } = useRidesNavigation();
  const idOpen = Number(id) && !isAddRoute ? Number(id) : undefined;
  const idCopyFrom = Number(id) && isAddRoute ? Number(id) : undefined;
  return (
    <RideEditFormDrawer
      type={DrawerType.RideEditForm}
      mode={EditFormMode.CrudRoute}
      onCloseDrawer={navigateRidesGridOrKanbanOrMap}
      id={idOpen}
      idCopyFrom={idCopyFrom}
    />
  );
};
